module.exports = __webpack_public_path__ + "img/modalcover.2834c3eb.jpg";